import React, { useEffect, useState } from "react";
import axios from "axios";


export   function itemCompare(x,y){
     if (x<y){
        return -1;
     } else if (x>y){
        return 1;
     } else {
        return 0;
     }
    }

const CategoryCard = ({
                          type = "category",
                          moduleId,
                          sourceId,
                          selectedItems = [],
                          effectiveSelectedItems,
                          onSelectionChange,
                          onSearch = () => {},
                          setViewMode = () => {},
                          prefetchedItems = null,
                      }) => {
    const [items, setItems] = useState([]);
    const [tooltipContent, setTooltipContent] = useState("");
    const resolvedSelectedItems = Array.isArray(effectiveSelectedItems)
        ? effectiveSelectedItems
        : selectedItems;
    const [localSelected, setLocalSelected] = useState(
        Array.isArray(resolvedSelectedItems) ? resolvedSelectedItems : []
    );

    useEffect(() => {
        setLocalSelected(Array.isArray(resolvedSelectedItems) ? resolvedSelectedItems : []);
    }, [sourceId, resolvedSelectedItems]);

    const buildFeatureTree = (flatList) => {
        const featureMap = new Map();
        const tree = [];
        (flatList || []).forEach((item) => featureMap.set(item.id, { ...item, children: [] }));
        (flatList || []).forEach((item) => {
            if (item.parentFeatureId && featureMap.has(item.parentFeatureId)) {
                featureMap.get(item.parentFeatureId).children.push(featureMap.get(item.id));
            } else {
                tree.push(featureMap.get(item.id));
            }
        });
        return tree;
    };


    

    useEffect(() => {
        // ✅ If parent provided prefetched items, use them and skip fetch
        if (prefetchedItems) {
            if (type === "feature") {
                setItems(buildFeatureTree(prefetchedItems));
            } else {
                setItems(prefetchedItems);
            }
            return;
        }

        const fetchItems = async () => {
            try {
                const headers = {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "application/json",
                };

                let url = "";
                if (type === "category" && sourceId) {
                    url = `${process.env.REACT_APP_API_URL}/category-items/by-category/${sourceId}`;
                } else if (type === "feature" && sourceId) {
                    url = `${process.env.REACT_APP_API_URL}/features/by-module/${moduleId}/${sourceId}`;
                }

                if (!url) return;

                const response = await axios.get(url, { headers });
                console.log("flatlist ",response.data);
                const flatList = response.data.sort(itemCompare);

                if (type === "feature") {
                    setItems(buildFeatureTree(flatList));
                } else {
                    setItems(flatList);
                }
            } catch (err) {
                console.error(`Failed to fetch ${type} items`, err);
            }
        };

        fetchItems();
    }, [type, sourceId, moduleId, prefetchedItems]);

    const handleCheckboxChange = (itemId) => {
        setLocalSelected((prev) =>
            prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
        );
        const updated = localSelected.includes(itemId)
            ? localSelected.filter(id => id !== itemId)
            : [...localSelected, itemId];
        setLocalSelected(updated);
        //  if (onSelectionChange) onSelectionChange(updated);
        };

    const handleSearch = () => {
        setViewMode("Discovery Builder");
        onSearch(localSelected);
    };

    const renderFeatureTree = (nodes, depth = 0) =>
        (nodes || []).map((item) => (
            <div
                key={item.id}
                className="mb-2 ml-[calc(1rem_*_var(--depth))]"
                style={{ "--depth": depth }}
            >
                <div className="flex items-start">
                    <input
                        type="checkbox"
                        id={`cb-${item.id}`}
                        checked={localSelected.includes(item.id)}
                        onChange={() => handleCheckboxChange(item.id)}
                        className="mr-2 mt-1"
                    />
                    <label
                        htmlFor={`cb-${item.id}`}
                        className="text-sm text-gray-800"
                        onMouseOver={() => setTooltipContent(item.definition || "")}
                        onMouseOut={() => setTooltipContent("")}
                    >
                        {item.item || item.name}
                    </label>
                </div>
                {item.children?.length > 0 && renderFeatureTree(item.children, depth + 1)}
            </div>
        ));

    return (
        <div className="max-h-[400px] w-full max-w-4xl mx-auto mt-4 flex flex-col">
            <div className="flex-1 min-h-0 overflow-auto pr-2">
                {type === "feature"
                    ? renderFeatureTree(items)
                    : (items || []).map((item) => (
                        <div key={item.id} className="flex items-start mb-2">
                            <input
                                type="checkbox"
                                id={`cb-${item.id}`}
                                checked={localSelected.includes(item.id)}
                                onChange={() => handleCheckboxChange(item.id)}
                                className="mr-2 mt-1"
                            />
                            <label
                                htmlFor={`cb-${item.id}`}
                                className="text-sm text-gray-800"
                                onMouseOver={() => setTooltipContent(item.definition || "")}
                                onMouseOut={() => setTooltipContent("")}
                            >
                                {item.item || item.name}
                            </label>
                        </div>
                    ))}
            </div>

            <div className="mt-4">
                <button
                    type="button"
                    onClick={handleSearch}
                    className="
            px-6 py-2.5 bg-[#25408f] text-white rounded-2xl font-semibold shadow-md
            hover:bg-[#1f367a] active:bg-[#1e3372] active:scale-95 transition-all duration-200
            focus:outline-none focus:ring-2 focus:ring-[#465da0] focus:ring-offset-2
            border border-[#25408f] hover:border-[#1e3372] active:border-[#1c306b]
            disabled:bg-[#25408f] disabled:border-[#25408f] disabled:opacity-60 disabled:cursor-not-allowed
            flex items-center gap-2
          "
                >
                    Search
                </button>

                {tooltipContent && (
                    <div className="mt-2 p-2 bg-yellow-100 border border-yellow-400 rounded text-sm">
                        {tooltipContent}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CategoryCard;
